
















































// vue
import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// componnents
import { PageHeader } from '@/components'
import { Modal } from '@/components/general'
import { BondTypesTableList, BondTypeFormCreateEdit } from '@/components/config'

// services
import { BondTypesService } from '@/services/config'

// models
import { Paginator } from '@/models'
import { BondType, BondTypeForm } from '@/models/config'

// utils
import { loading, alerts } from '@/utils'

// constants
import { actionFormTypes } from '@/constants'

const bondTypeDefault: BondTypeForm = {
  name: '',
  code: '',
  is_active: true,
  is_massive: false,
  amount_fortnight: 0
}

export default defineComponent({
  name: 'BondTypesIndex',
  components: {
    PageHeader,
    BondTypesTableList,
    Modal,
    BondTypeFormCreateEdit
  },
  setup () {
    const showModal = ref(false)
    const title = 'Tipos de Bonos'
    const actionForm = ref(actionFormTypes)
    const idEdit: Ref<number|null> = ref(null)
    const titleModal = computed(() => {
      if (actionForm.value === 'update') {
        return 'Editar Tipo de Bono'
      }
      return 'Crear Tipo de Bono'
    })
    const items = [
      {
        text: 'Dashboard'
      },
      {
        text: 'Tipos de Bonos',
        active: true
      }
    ]
    const pagination: Ref<Paginator> = ref({
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    })
    const bondType: Ref<BondTypeForm> = ref(bondTypeDefault)
    const bondTypes: Ref<BondType[]> = ref([])
    const getBondTypesWithPagination = async () => {
      loading('show')
      const res = await BondTypesService.getWithPagination(pagination.value.perPage, pagination.value.currentPage)
      pagination.value = res.pagination
      bondTypes.value = res.objects
      loading('hide')
    }
    getBondTypesWithPagination()
    const addNew = () => {
      actionForm.value = 'save'
      showModal.value = true
      bondType.value = {
        ...bondTypeDefault
      }
    }
    const saveSuccess = () => {
      showModal.value = false
      actionForm.value = 'save'
      bondType.value = {
        ...bondTypeDefault
      }
      idEdit.value = null
      getBondTypesWithPagination()
    }
    const editItem = (item: BondType) => {
      bondType.value = {
        name: item.name,
        code: item.code,
        is_active: item.is_active,
        is_massive: item.is_massive,
        amount_fortnight: item.amount_fortnight
      }
      idEdit.value = Number(item.id)
      actionForm.value = 'update'
      showModal.value = true
    }

    const deleteItem = async (item: BondType) => {
      const msg = `Seguro que desea eliminar el Tipo de Bono: ${item.name}`
      const confirm = await alerts.confirm(msg)
      if (confirm) {
        loading('show')
        await BondTypesService.delete(item.id)
        alerts.success()
        getBondTypesWithPagination()
      }
    }

    const changeStatus = async (item: BondType) => {
      loading('show')
      await BondTypesService.update(Number(item.id), {
        name: item.name,
        code: item.code,
        is_active: !item.is_active,
        is_massive: item.is_massive,
        amount_fortnight: item.amount_fortnight
      })
      loading('hide')
      getBondTypesWithPagination()
    }

    const changePage = (page: number) => {
      pagination.value.currentPage = page
      getBondTypesWithPagination()
    }

    const changePerPage = (perPage: number) => {
      pagination.value.perPage = perPage
      pagination.value.currentPage = 1
      getBondTypesWithPagination()
    }

    return {
      items,
      title,
      addNew,
      showModal,
      titleModal,
      bondType,
      saveSuccess,
      bondTypes,
      deleteItem,
      idEdit,
      editItem,
      actionForm,
      changeStatus,
      pagination,
      changePage,
      changePerPage
    }
  }
})
